import {
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  SECURE_PAYMENT_SET_SPLIT,
  SECURE_PAYMENT_SET_PENDING,
  SECURE_PAYMENT_SET_PROCESSING,
  SECURE_PAYMENT_SET_ERROR,
  SECURE_PAYMENT_SET_MERCHANT_FEE_PAYMENT_TYPE,
  SECURE_PAYMENT_SET_STRIPE_PAYMENT_METHOD,
  SECURE_PAYMENT_SET_INFO,
  SECURE_PAYMENT_SET_PAID,
  SECURE_PAYMENT_SET_LOADING,
  SECURE_PAYMENT_SET_EXPIRED,
  SECURE_PAYMENT_SET_INVALID,
  SECURE_PAYMENT_SET_SUCCESS,
} from 'actions/actionConstants'
import {
  CREATE_STRIPE_PAYMENT_METHOD_SECURE_PAYMENT,
} from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'

export const initialSecurePaymentState: App.SecurePaymentState = {
  status: 'loading',
  splitPayment: { isPreparing: false, isActive: false, isLocked: false, legs: null, merchantFeeAmount: null },
  stripePaymentMethod: {
    isCreatingStripePaymentMethod: false,
    paymentMethodId: undefined,
    cardBrand: undefined,
    cardFunding: undefined,
    cardCountry: undefined,
    walletType: undefined,
  },
  merchantFeePaymentType: undefined,
  data: undefined,
}

const apiCalls = apiReducerSwitch<App.SecurePaymentState>({
  [CREATE_STRIPE_PAYMENT_METHOD_SECURE_PAYMENT]: {
    request: (state): App.SecurePaymentState => ({
      ...state,
      stripePaymentMethod: {
        ...state.stripePaymentMethod,
        isCreatingStripePaymentMethod: true,
        cardBrand: undefined,
        cardFunding: undefined,
        paymentMethodId: undefined,
        cardCountry: undefined,
      },
    }),
    success: (state, action): App.SecurePaymentState => ({
      ...state,
      stripePaymentMethod: {
        ...state.stripePaymentMethod,
        isCreatingStripePaymentMethod: false,
        cardBrand: action.data.paymentMethod?.card?.brand,
        cardFunding: action.data.paymentMethod?.card?.funding,
        cardCountry: action.data.paymentMethod?.card?.country ?? undefined,
        paymentMethodId: action.data.paymentMethod?.id,
        walletType: action.data.paymentMethod?.card?.wallet?.type,
      },
    }),
    failure: (state): App.SecurePaymentState => ({
      ...state,
      stripePaymentMethod: {
        ...state.stripePaymentMethod,
        isCreatingStripePaymentMethod: false,
      },
    }),
  },
})

const securePaymentReducer = createAppReducer<App.SecurePaymentState>(initialSecurePaymentState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
  [SECURE_PAYMENT_SET_STRIPE_PAYMENT_METHOD]: (state, action): App.SecurePaymentState => ({
    ...state,
    stripePaymentMethod: {
      ...state.stripePaymentMethod,
      ...action.paymentMethod,
    },
  }),
  [SECURE_PAYMENT_SET_MERCHANT_FEE_PAYMENT_TYPE]: (state, action): App.SecurePaymentState => ({
    ...state,
    merchantFeePaymentType: action.paymentType,
  }),
  [SECURE_PAYMENT_SET_SPLIT]: (state, action): App.SecurePaymentState => ({
    ...state,
    splitPayment: { ...state.splitPayment, ...action.splitPayment },
  }),
  [SECURE_PAYMENT_SET_PENDING]: (state): App.SecurePaymentState => ({ ...state, status: 'pending' }),
  [SECURE_PAYMENT_SET_INFO]: (state, action): App.SecurePaymentState => ({
    ...state,
    status: 'pending',
    data: {
      ...state.data,
      type: action.data.type,
      amount: action.data.amount,
      currency: action.data.currency,
      orderId: action.data.orderId,
      customerId: action.data.customerId,
      brand: action.data.brand,
      isDeposit: action.data.isDeposit,
      isDepositBalance: action.data.isDepositBalance,
      hasLuxPlus: action.data.hasLuxPlus,
      splitPayment: action.data.splitPayment,
      items: action.data.items,
      promoAmount: action.data.promoAmount,
      creditAmount: action.data.creditAmount,
      balanceAmount: action.data.balanceAmount,
      balanceDueDate: action.data.balanceDueDate,
      metadata: action.data.metadata,
    },
  }),
  [SECURE_PAYMENT_SET_PROCESSING]: (state): App.SecurePaymentState => ({
    ...state,
    status: 'processing',
  }),
  [SECURE_PAYMENT_SET_ERROR]: (state): App.SecurePaymentState => ({
    ...state,
    status: 'error',
  }),
  [SECURE_PAYMENT_SET_PAID]: (state): App.SecurePaymentState => ({
    ...state,
    status: 'paid',
  }),
  [SECURE_PAYMENT_SET_LOADING]: (state, action): App.SecurePaymentState => ({
    ...state,
    status: 'loading',
    paymentLinkId: action.paymentLinkId,
    splitPayment: initialSecurePaymentState.splitPayment,
  }),
  [SECURE_PAYMENT_SET_INVALID]: (state): App.SecurePaymentState => ({
    ...state,
    status: 'invalid',
    splitPayment: { ...state.splitPayment, isLocked: true },
  }),
  [SECURE_PAYMENT_SET_EXPIRED]: (state): App.SecurePaymentState => ({
    ...state,
    status: 'expired',
  }),
  [SECURE_PAYMENT_SET_SUCCESS]: (state): App.SecurePaymentState => ({
    ...state,
    status: 'success',
  }),
})

export default securePaymentReducer
